import {
  FETCH_LOGS_START,
  FETCH_LOGS_SUCCESS,
  FETCH_LOGS_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  logData: {},
  isFetching: true,
  errorMessage: '',
}

const logReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LOGS_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_LOGS_SUCCESS:
      return {
        ...state,
        logData: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_LOGS_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default logReducer
